import { render, staticRenderFns } from "./search.pug?vue&type=template&id=a0fd5576&lang=pug&"
import script from "./search.js?vue&type=script&lang=js&"
export * from "./search.js?vue&type=script&lang=js&"
import style0 from "./search.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CVM7Z9V\\OneDrive - Allianz\\Escritorio\\apps\\mavalue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0fd5576')) {
      api.createRecord('a0fd5576', component.options)
    } else {
      api.reload('a0fd5576', component.options)
    }
    module.hot.accept("./search.pug?vue&type=template&id=a0fd5576&lang=pug&", function () {
      api.rerender('a0fd5576', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/search/index.vue"
export default component.exports